import Header from "./components/Header";
import Hero from "./components/Hero";
import About from './components/About.jsx';
import Skills from './components/Skills';
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className='h-screen bg-[#f3f3f3] snap-y snap-mandatory overflow-y-scroll 
    overflow-x-hidden z-0 scrollbar scrollbar-track-gray-400/20 scrollbar-thumb-[#000000]/80'>
      <Header />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
      <a href="#hero">
        <footer className='relative bottom-12 w-full cursor-pointer h-0'> 
            <div className='flex justify-center items-center animate-bounce'>
              <img 
                className='h-8 w-8 rounded-full filter grayscale hover:grayscale-0 cursor-pointer'
                src="https://www.pngfind.com/pngs/m/16-161912_up-arrow-transparent-images-double-up-arrow-icon.png" 
                alt="" 
              />
            </div>
        </footer>
      </a>
    </div>
  );
}

export default App;
